import { projects, type Project } from './projects';

const TOTAL_USERS_ROUNDING = 1000;

type UserReach = Extract<NonNullable<Project['reach']>, { kind: 'users' }>;

export function userReach(project: Project): UserReach | undefined {
    return project.reach?.kind === 'users' ? project.reach : undefined;
}

export function roundedTotalUsers(): number {
    const total = projects.reduce((sum, project) => sum + (userReach(project)?.count ?? 0), 0);
    return Math.floor(total / TOTAL_USERS_ROUNDING) * TOTAL_USERS_ROUNDING;
}

export function userCountAffixes(reach: UserReach): { prefix: string; suffix: string } {
    return reach.precision === 'atLeast' ? { prefix: '', suffix: '+' } : { prefix: '~', suffix: '' };
}
